import { CurrencyEnum } from '_app/graphql/generated/graphql'
import LocalStorageHelper from '../../../helpers/LocalStorageHelper/LocalStorageHelper'
import ConfigurationHelper from '../../../helpers/ConfigurationHelper/ConfigurationHelper'

const getFreeDeliveryThreshold = (locale?: string, router?: any) => {
  const freeshipping_price = Number(ConfigurationHelper.getConfiguration('freeshipping_price', router))
  switch (locale) {
    case 'en':
      return {
        freeDeliveryThresholdCurrency: CurrencyEnum.Gbp,
        freeDeliveryThresholdValue: freeshipping_price,
      }
    case 'de':
    case 'fr':
      return {
        freeDeliveryThresholdCurrency: CurrencyEnum.Eur,
        freeDeliveryThresholdValue: freeshipping_price,
      }
    default:
      return {
        freeDeliveryThresholdCurrency: CurrencyEnum.Pln,
        freeDeliveryThresholdValue: freeshipping_price,
      }
  }
}

export default getFreeDeliveryThreshold
